/**
 * @generated SignedSource<<8e35b6fa12d19cfa4a36c837698d460a>>
 * @relayHash c217df70d0e497ed57421ef4d706bf40
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c217df70d0e497ed57421ef4d706bf40

import { ConcreteRequest } from 'relay-runtime';
export type Country = "CH" | "DE";
export type ConsultEmergencyServiceInput = {
  country: Country;
  emergencyPhoneNumber: string;
  patientId?: string | null;
  phoneNumbers: ReadonlyArray<string>;
};
export type useConsultEmergencyServiceMutation$variables = {
  input: ConsultEmergencyServiceInput;
};
export type useConsultEmergencyServiceMutation$data = {
  readonly consultEmergencyService: {
    readonly errors: ReadonlyArray<{
      readonly __typename: "AgentNotAuthenticated";
    } | {
      readonly __typename: "ConsultAlreadyInProgress";
    } | {
      readonly __typename: "ConsultRejected";
    } | {
      readonly __typename: "InvalidEmergencyPhoneNumber";
    } | {
      readonly __typename: "InvalidPatientPhoneNumber";
    } | {
      readonly __typename: "NoActiveCallFound";
    } | {
      readonly __typename: "PatientNotOnCall";
    } | {
      readonly __typename: "SeveralActiveCallsFound";
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    }> | null;
  };
};
export type useConsultEmergencyServiceMutation = {
  response: useConsultEmergencyServiceMutation$data;
  variables: useConsultEmergencyServiceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useConsultEmergencyServiceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "ConsultEmergencyServicePayload",
        "kind": "LinkedField",
        "name": "consultEmergencyService",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": (v2/*:: as any*/),
                "type": "AgentNotAuthenticated",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v2/*:: as any*/),
                "type": "InvalidEmergencyPhoneNumber",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v2/*:: as any*/),
                "type": "InvalidPatientPhoneNumber",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v2/*:: as any*/),
                "type": "NoActiveCallFound",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v2/*:: as any*/),
                "type": "SeveralActiveCallsFound",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v2/*:: as any*/),
                "type": "PatientNotOnCall",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v2/*:: as any*/),
                "type": "ConsultAlreadyInProgress",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v2/*:: as any*/),
                "type": "ConsultRejected",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useConsultEmergencyServiceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "ConsultEmergencyServicePayload",
        "kind": "LinkedField",
        "name": "consultEmergencyService",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": (v2/*:: as any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "c217df70d0e497ed57421ef4d706bf40",
    "metadata": {},
    "name": "useConsultEmergencyServiceMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "b9050576b5efae821ba77b8caeb25b75";

export default node;
